export class DriverId {
  id: number
  constructor(
    id: number
  ){
    this.id = id;
  }
}

export class driverIdReq{
  
  vendorId?:number
  role?:string
  plant?:string
  extNo?:string
  val?:string
  constructor(
    vendorId?:number,
  role?:string,
  plant?:string,
  extNo?:string,
  val?:string
  ){
    this.vendorId=vendorId,
      this.role=role
      this.plant=plant
      this.extNo=extNo
      this.val=val
  }
}